import React, { useCallback, useState } from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import { EmployerLockUnlockModal } from '../../EmployerLockUnlockModal';
import { useIsLockUnlockAvailable } from '../../EmployerLockUnlockModal/hooks/useIsLockUnlockAvailable';
import { ButtonHintForTerminatedEmployer } from '../../EmployerTermination/ButtonHintForTerminatedEmployer';

interface Props {
  isLocked?: boolean;
  employerName?: string;
  employerId?: string;
}

const OrganisationLock: React.FC<Props> = ({ isLocked, employerName, employerId }) => {
  const [showLockModal, setShowLockModal] = useState<boolean>(false);
  const handleCloseLockModal = useCallback(() => setShowLockModal(false), [setShowLockModal]);
  const { isLockUnlockDisabled, tooltipText } = useIsLockUnlockAvailable();
  return (
    <>
      <Box
        data-testid="technical-settings-wrapper"
        direction="row"
        background="canvas"
        round="container1Round"
        border={{ color: 'border2', size: 'small' }}
        pad="l"
        justify="between"
      >
        <Box>
          <Text weight="bold">Lock Organization</Text>
          <Text size="small" color="textSecondary">
            By locking this organization, payments from any organization funded accounts will not be
            processed.
          </Text>
        </Box>
        <ButtonHintForTerminatedEmployer
          button={
            <AppButton
              width="113px"
              buttonType="secondary"
              onClick={() => setShowLockModal(true)}
              disabled={isLockUnlockDisabled}
            >
              {isLocked ? 'Unlock' : 'Lock'}
            </AppButton>
          }
          isTerminatedEmployer={isLockUnlockDisabled}
          hintText={tooltipText}
        />
      </Box>
      <EmployerLockUnlockModal
        visible={showLockModal}
        employerId={employerId}
        employerName={employerName}
        isLockMode={!isLocked}
        onSetVisible={handleCloseLockModal}
      />
    </>
  );
};

export default OrganisationLock;
